import { buildApiUrl, API_CONFIG } from "./config";
import { post } from "./request";
// 获取视频上传签名的接口
export interface VideoUploadSignature {
  signature: string;
  appId?: number;
  reportId?: number;
}

// 获取视频上传签名
export const getVideoUploadSignature = (): Promise<VideoUploadSignature> => {
  const url = buildApiUrl(
    API_CONFIG.CONTROLLERS.VIDEO,
    API_CONFIG.ACTIONS.GET_KEY
  );
  return post<VideoUploadSignature>(url);
};

// 视频上传完成后的回调接口
export interface VideoUploadCallback {
  fileId: string;
  videoUrl: string;
  coverUrl?: string;
}

// 视频上传完成回调
